import { Component, model, OnInit } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { TripSummaryTab } from '../../enums';

import { SummaryComponent } from './summary/summary.component';
import { PassengersComponent } from './passengers/passengers.component';
import { ItineraryComponent } from './itinerary/itinerary.component';
import { TicketPricesComponent } from './ticket-prices/ticket-prices.component';
import { TicketRulesComponent } from './ticket-rules/ticket-rules.component';

@Component({
  selector: 'app-trip-summary',
  templateUrl: './trip-summary.component.html',
  standalone: true,
  imports: [
    NgbNavModule,
    SummaryComponent,
    PassengersComponent,
    ItineraryComponent,
    TicketPricesComponent,
    TicketRulesComponent,
  ],
})
export class TripSummaryComponent implements OnInit {
  readonly tabsAvailable = model<TripSummaryTab[]>([
    TripSummaryTab.Itinerary,
    TripSummaryTab.TicketPrices,
    TripSummaryTab.TicketConditions,
  ]);
  readonly activeTab = model<TripSummaryTab>(TripSummaryTab.Itinerary);
  readonly TripSummaryTab = TripSummaryTab;

  ngOnInit(): void {}
}
